// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"8524ebc6","49":"c4172d58","266":"905de562","327":"91872e94","356":"a45f444c","523":"376c31a1","536":"28217278","818":"ccc85a33","850":"7a45c89a","892":"5689bb31","950":"d90e3522","974":"3606cb34"}[chunkId] + ".chunk.js";
};